module.exports = __webpack_public_path__ + "img/labelsNumbersOrdered.2dc78812.svg";